module.exports = __webpack_public_path__ + "static/media/speakersNew.46955623.jpeg";